import { render, staticRenderFns } from "./bulletin.vue?vue&type=template&id=60860b4a&"
import script from "./bulletin.vue?vue&type=script&lang=js&"
export * from "./bulletin.vue?vue&type=script&lang=js&"
import style0 from "./bulletin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports